import { RecordByPrimaryKey } from "@pdfking/templates"

import type { OrientationKind } from "#internal"

// Force-landscape orientation (Python `enforce_landscape` uses the plain
// landscape opening): rotate any portrait canvas to landscape.
export const LANDSCAPE: OrientationKind = {
  id: "l",
  name: "ORIENTATION_KIND_L",
  is_portrait: false,
  opening_top: false,
  can_set_orientation: true,
}

export const OrientationKindList = RecordByPrimaryKey<OrientationKind>([
  LANDSCAPE,
  {
    id: "lv",
    name: "ORIENTATION_KIND_LV",
    is_portrait: false,
    opening_top: true,
    can_set_orientation: true,
  },
  {
    id: "p",
    name: "ORIENTATION_KIND_P",
    is_portrait: true,
    opening_top: false,
    can_set_orientation: true,
  },
  {
    id: "pv",
    name: "ORIENTATION_KIND_PV",
    is_portrait: true,
    opening_top: true,
    can_set_orientation: true,
  },
  {
    id: "n",
    name: "ORIENTATION_KIND_N",
    is_portrait: false,
    opening_top: false,
    can_set_orientation: false,
  },
  {
    id: "nv",
    name: "ORIENTATION_KIND_NV",
    is_portrait: true,
    opening_top: true,
    can_set_orientation: false,
  },
] as const)
